import { useQuery } from '@tanstack/react-query';
import type { SegmentDimension, SegmentIncomeStatementResponse } from '@accounting/shared';
import { api } from '../lib/api';

export function useSegmentIncomeStatement(
  companyId: string | null,
  from: string,
  to: string,
  dimension: SegmentDimension,
) {
  return useQuery({
    queryKey: ['segment-income-statement', companyId ?? 'none', from, to, dimension],
    enabled: companyId !== null && !!from && !!to,
    queryFn: () =>
      api.get<SegmentIncomeStatementResponse>(`/companies/${companyId}/reports/segment-income-statement`, { from, to, dimension }),
  });
}
